import React, { Component } from 'react';
import { Consumer } from "../../context";

import Request from "../../core/httpClient";
import Socket from '../../core/socket';

const request = new Request();

let timer;

class Sidebar extends Component {
    state = {
		fraccionamientos: [],
		subfraccionamientos: [],
		fraccionamiento: "0",
		subfraccionamiento: "0"
    }

	componentDidMount() {
		this.getFraccionamientos();
		Socket.on('saludo', () =>{
			alert('Me saluda el api')
		})
	}

	componentWillUnmount() {
		clearTimeout(timer);
	}

	async getFraccionamientos() {

		const user = await this.props.context.loadUser();
		this.setState({user});

		let data = { 
			IdAdministracion: user.id.id_administracion,
			IdFraccionamiento: user.id.id_fraccionamiento
		}
					 
		const response = await request.post("/admin/administracion/get/fraccionamientos", data);
		if (response && !response.error) {
			if (response.fraccionamientos && !response.empty) {
				this.setState({
					fraccionamientos: response.fraccionamientos
				});
				if(response.fraccionamientos.length > 0) {
					const fracc = localStorage.getItem('frac') || response.fraccionamientos[0].id_fraccionamiento;
					const fraccionamiento = this.state.fraccionamientos.find(fraccionamiento => fraccionamiento.id_fraccionamiento.toString() === fracc.toString())
					if(fraccionamiento) {
						this.props.context.setNombreFraccionamiento(fraccionamiento.nombre);
					}
					if(!localStorage.getItem('frac')) {
						localStorage.setItem('frac', response.fraccionamientos[0].id_fraccionamiento);
						this.props.context.getMenus(response.fraccionamientos[0].id_fraccionamiento);
						this.setState({fraccionamiento: response.fraccionamientos[0].id_fraccionamiento});
					} else {
						this.setState({fraccionamiento: fracc || 0});
					}
				}
			} else {
				this.setState({
					empty: true,
					message: response.message
				});
			}
		} else {
			this.setState({
				error: true,
				message: response.message
			});

		}
	}

	applyChanges() {
		/** Asigna el ID de Fraccionamiento en localStorage */
		localStorage.removeItem('subfrac');
		localStorage.setItem('frac', this.state.fraccionamiento);
		const fracc = this.state.fraccionamientos.find(fraccionamiento => fraccionamiento.id_fraccionamiento.toString() === this.state.fraccionamiento.toString())
		this.props.context.setFraccionamiento(this.state.fraccionamiento);
		this.props.context.setNombreFraccionamiento(fracc.nombre);
		this.props.context.getMenus(this.state.fraccionamiento);
		const leftbar = document.getElementById('rightsidebar');
		if(leftbar) {
			leftbar.classList.toggle('open');
		}
		timer = setTimeout(() => {
			window.location.reload();
		}, 600)
	}

	probarSocket() {
		Socket.emit('saludo', {...this.state})
	}

	changeFraccionamiento(event) {
		this.setState({fraccionamiento: event.target.value});
	}

    render() {
		let user = {}
		if(this.state.user) {
			user = this.state.user.id;
		}
        return (
            <div id="rightsidebar" className="rightsidebar row">
				<div className="column container">
					<h4 className="accordion color-white">{user.nombre}</h4>
					<div className="white-space-16"></div>
					<span className="accordion color-white">Fraccionamiento:</span>
					<div className="white-space-8"></div>
					<select name="fraccionamiento" id="fraccionamiento" className="input input-select full"
						value={this.state.fraccionamiento}
						onChange={this.changeFraccionamiento.bind(this)}>
						{  
							this.state.fraccionamientos.map((fraccionamiento, key) => (
							<option value={fraccionamiento.id_fraccionamiento} key={key}>{fraccionamiento.nombre}</option>)) 
						}
					</select>
					<div className="white-space-16"></div>
					<button className="btn btn-primary btn-small color-white" onClick={this.applyChanges.bind(this)}>
						Aplicar
					</button>
				</div>
            </div>
        );
    }
}

export default Consumer(Sidebar);